<template>
  <div>
    <h1 class="mb-0">{{ $t("public.newPassword.title") }}</h1>
    <p>
      {{ $t("public.newPassword.text") }}
    </p>
    <form class="mt-4 form-auth-pages">
      <b-form-group label-for="password">
        <template slot="label">{{ $t("public.newPassword.form.pwd") }}: *
        </template>
        <b-form-input id="password" v-model="password" type="password" v-bind:class="{
          'text-danger': isFormPasswordErrors,
          'is-invalid': isFormPasswordErrors,
        }" @blur="checkPassword(password)"></b-form-input>
        <ul v-if="isFormPasswordErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('password')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="passwordConfirm">
        <template slot="label">{{ $t("public.newPassword.form.pwdConfirm") }}: *
        </template>
        <b-form-input id="passwordConfirm" v-model="passwordConfirm" type="password" v-bind:class="{
          'text-danger': isFormPasswordConfirmErrors,
          'is-invalid': isFormPasswordConfirmErrors,
        }" @blur="checkPasswordConfirm(passwordConfirm, password)"></b-form-input>
        <ul v-if="isFormPasswordConfirmErrors">
          <li v-for="(error, index) in validatorStep1.getErrors(
            'passwordConfirm'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <div class="d-inline-block w-100">
        <b-button ref="btnVolver" class="btn btn-primary float-right ml-2" variant="primary" @click="routeBack">{{
          $t("public.newPassword.form.btnBack")
        }}
        </b-button>
        <b-button class="btn btn-success float-right ml-2" variant="success" @click="saveFormStep1">{{
          $t("public.newPassword.form.btnReset")
        }}
        </b-button>
      </div>
    </form>
    <notifications group="notificacions" />
  </div>
</template>
<script>
import routes from "../../router/index";

//JSON Mock
import SignFooter from "../../json/SignFooter";

import validator from "vue-m-validator";

import utilsService from "../../services/utils";

export default {
  name: "NewPassword",
  data() {
    return {
      //Data validate form
      isFirstRun: true,
      //Form registrate
      password: "",
      passwordConfirm: "",
      token: this.$route.query.token,

      footerMenu: SignFooter,

      validatorStep1: validator,
    };
  },
  computed: {
    //Form step 1
    isFormPasswordErrors() {
      let errors = this.validatorStep1.getErrors("password");
      return errors && errors.length > 0;
    },
    isFormPasswordConfirmErrors() {
      let errors = this.validatorStep1.getErrors("passwordConfirm");
      return errors && errors.length > 0;
    },
  },
  methods: {
    routeBack() {
      this.$router.push({ name: "public.signin" });
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkFormStep1() {
      this.checkPassword(this.password);
      this.checkPasswordConfirm(this.passwordConfirm, this.password);
    },
    saveFormStep1() {
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        this.sendNewPassword();
      } else {
        this.$notify({
          group: "notificacions",
          title: "¡Error!",
          text: "Hay errores al validar el formulario step 1",
          type: "error",
        });
      }
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "password",
        msg: "El password no puede estar vacio",
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "password",
        msg: "Utiliza 6 caracteres como mínimo con una combinación de letras y números",
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkPasswordConfirm(_passwordConfirm, _password) {
      const PASSWORDCONFIRM = _passwordConfirm.trim();
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORDCONFIRM || PASSWORDCONFIRM === "",
        name: "passwordConfirm",
        msg: "El password confirm no puede estar vacio",
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORDCONFIRM),
        name: "passwordConfirm",
        msg: "Utiliza 6 caracteres como mínimo con una combinación de letras y números",
      };
      const RULE_3 = {
        expression: PASSWORDCONFIRM !== PASSWORD,
        name: "passwordConfirm",
        msg: "La confirmación del password tiene que ser igual al password",
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    sendNewPassword() {
      let object = {
        password: this.password,
        token: this.token,
      };

      this.$awn.asyncBlock(
        utilsService.sendNewPassword(object),
        (response) => {
          if (response) {
            routes.push({ name: "public.signin" });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "utilsService.sendNewPassword",
            module: "view-authpages-newPassword",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              object: object
            })
          });
        },
        " "
      );
    },
  },
};
</script>
